import { Check, Leaf } from "lucide-react";

export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand-mark" aria-label="เข้างาน">
      <span className="brand-symbol" aria-hidden="true"><Leaf size={20} /><Check size={13} /></span>
      {!compact && <span>เข้างาน</span>}
    </div>
  );
}
